import { Injectable } from '@angular/core';
import { ApiHelperService } from '../../core/api-helper.service';
import { ErrorContext, ServerError } from '../errors/error.model';

import { PaymentPlan, PaymentPlanType } from './payment-plan.model';

class FetchPaymentPlanError extends ServerError {
    constructor(msg: string, ctx?: ErrorContext) {
        super(msg, ctx);
        this.ctx.userMessage = 'We could not fetch payment plans. Support has been notified.';
    }
}
@Injectable({
    providedIn: 'root'
})
export class PaymentPlanService {

    options = { authenticate: false, setRoot: true };
    
    constructor(private api: ApiHelperService) { }

    getAllPlans(): Promise<PaymentPlan[]> {
        return this.api.apiCallSane(
            '/payment-plans',
            'GET',
            this.api.getDefaultHeaders(),
            null,
            null,
            this.options)
        .then(plans => plans.map(p => new PaymentPlan(p)))
        .catch(e => { throw FetchPaymentPlanError.upgrade(e); });
    }

    getInvoicePlans(): Promise<PaymentPlan[]> {
        return this.api.apiCallSane(
            '/payment-plans',
            'GET',
            this.api.getDefaultHeaders(),
            { planType: PaymentPlanType.INVOICE },
            null,
            this.options)
        .then(plans => plans.map(p => new PaymentPlan(p)))
        .catch(e => { throw FetchPaymentPlanError.upgrade(e); });
    }

    getCreditPlans(): Promise<PaymentPlan[]> {
        return this.api.apiCallSane(
            '/payment-plans',
            'GET',
            this.api.getDefaultHeaders(),
            { planType: PaymentPlanType.CREDITS },
            null,
            this.options)
        .then(plans => plans.map(p => new PaymentPlan(p)))
        .catch(e => { throw FetchPaymentPlanError.upgrade(e); });
    }

    getAdhocPlans(): Promise<PaymentPlan[]> {
        return this.api.apiCallSane(
            '/payment-plans',
            'GET',
            this.api.getDefaultHeaders(),
            { planType: PaymentPlanType.ADHOC },
            null,
            this.options)
        .then(plans => plans.map(p => new PaymentPlan(p)))
        .catch(e => { throw FetchPaymentPlanError.upgrade(e); });
    }

    getFeePlans(): Promise<PaymentPlan[]> {
        return this.api.apiCallSane(
            '/payment-plans',
            'GET',
            this.api.getDefaultHeaders(),
            { planType: PaymentPlanType.FEE },
            null,
            this.options)
        .then(plans => plans.map(p => new PaymentPlan(p)))
        .catch(e => { throw FetchPaymentPlanError.upgrade(e); });
    }

    async getPlanById(id:string): Promise<PaymentPlan> {
        return this.api.apiCallSane(
            '/payment-plan',
            'GET',
            this.api.getDefaultHeaders(),
            { id },
            null,
            this.options)
        .then(p => new PaymentPlan(p))
        .catch(e => { throw FetchPaymentPlanError.upgrade(e); });
    }
}
